import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  addServicesButton: {
    margin: `${theme.spacing(1.2)} 0`,
  },

  bottomRightContainer: {
    [theme.breakpoints.up('lg')]: {},
    [theme.breakpoints.down('lg')]: {
      textAlign: 'right',
    },
  },

  button: {
    [theme.breakpoints.up('lg')]: {
      margin: `${theme.spacing(2)} 0`,
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },

  card: {
    padding: theme.spacing(1.5),
  },

  container: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'row',
    },
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '22px',
    lineHeight: '160%',
    marginBottom: theme.spacing(1.5),
  },

  topLeftContainer: {
    [theme.breakpoints.up('lg')]: {},
    [theme.breakpoints.down('lg')]: {},
  },

  validationError: {
    color: theme.palette.error.dark,
    fontSize: '14px',
    paddingLeft: theme.spacing(1),
  },
})
